import React, { useState } from "react";
import AddMenuForm from "../../components/menu/AddMenuForm/AddMenuForm";
import { Container, Paper } from "@material-ui/core";
import Loading from "../../components/Loading/Loading";
import { useStyles } from "../../assets/styles";
import CategoryAction from "../../components/menu/CategoryAction/CategoryAction";
const CATEGORIES = "categories";
const ADD = "add";

export default function AddMenu({ path }) {
	const [progress, setProgress] = useState({ label: "", value: 0 });
	const [isLoading, setIsLoading] = useState(false);

	const handleProgress = (label, value) => {
		setProgress({
			label,
			value,
		});
	};

	const handleLoading = (state) => setIsLoading(state);

	const menuPointer = {
		[CATEGORIES]: CategoryAction,
		[ADD]: AddMenuForm,
	};

	const RenderedComponent = menuPointer[path];

	const classes = useStyles();
	return (
		<Container className={classes.root}>
			<Paper className={classes.paper}>
				{isLoading && <Loading progress={progress} />}
				<RenderedComponent handleProgress={handleProgress} handleLoading={handleLoading} isLoading={isLoading} />
			</Paper>
		</Container>
	);
}
